export default __webpack_public_path__ + "static/media/24 NEWS.0b8b918a.png";